/*
 * @Description: 支付运费-月账单-store
 * @Author: lijinpeng
 * @Date: 2022-06-17 14:53:55
 * @LastEditTime: 2023-09-19 10:59:43
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { getSettlementCollectInfoByBid } from '@/api/freight';

const state = {
  // 接口调用参数
  postParams: {
    businessId: '', // 企业ID
    current: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '月份',
        prop: 'month',
        width: 110,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-month',
      },
      {
        label: '储值次数',
        prop: 'rechargeTime',
        width: 110,
        checked: 1,
        sortable: true,
      },
      {
        label: '储值金额',
        prop: 'rechargeAmt',
        width: 110,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-rechargeAmt',
      },
      {
        label: '结算次数',
        prop: 'settlementTime',
        width: 85,
        checked: 1,
        sortable: true,
      },
      {
        label: '支付总额',
        prop: 'payAmt',
        width: 115,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payAmt',
      },
      {
        label: '运费总额',
        prop: 'settlementAmt',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-settlementAmt',
      },
      {
        label: '服务费总额',
        prop: 'hangingAmt',
        width: 115,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-hangingAmt',
      },
      {
        label: '抵扣税额',
        prop: 'deductionAmt',
        width: 115,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-deductionAmt',
      },
      {
        label: '操作',
        prop: '',
        width: 145,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-status',
      },
    ],
  },
};

// getters
const getters = {};

// actions
const actions = {
  getList: async context => {
    const { data } = await getSettlementCollectInfoByBid({
      ...context.state.postParams,
    });
    context.commit('updateListData', Object.assign({}, context.state.listData, data));
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
